<template>
    <div class="container p-1">
        <div class="page-header">
            <h1><img class="align-center" alt="Vue logo" src="../assets/ccm.png" height="50"> Comment ça marche ?</h1>
            <hr>
        </div>
        <div class="card">
            <div class="card-body">
                <ul class="list-group list-group-flush">
                    <li class="list-group-item"><i class="fas fa-chevron-circle-right"></i> 1° Scanner le QRCODE</li>
                    <li class="list-group-item"><i class="fas fa-chevron-circle-right"></i> 2° Remplir le formulaire
                    </li>
                    <li class="list-group-item"><i class="fas fa-chevron-circle-right"></i> 3° Envoyer le formulaire
                    </li>
                    <li class="list-group-item"><i class="fas fa-chevron-circle-right"></i> 4° C'est déjà fini !</li>
                </ul>
            </div>
        </div>

    </div>

</template>

<script>

export default {
    name: 'Home',
}
</script>
